import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { TaskTimeTrackingEntryResource } from 'dy-frontend-http-repository/lib/modules/CoreUser/resources';

import domain from './domain';
import { resetTaskTimeTrackingEntries } from './events';

// Task time tracking entries
export const $taskTimeTrackingEntries = domain
    .createStore<CollectionResource<TaskTimeTrackingEntryResource, {}> | null>(null)
    .reset(resetTaskTimeTrackingEntries);
